/* eslint no-new: "off" */

import $ from "jquery";
import FileService from "./Service/FileService";

class ServiceFileManager {
  /**
   * html identifier
   *
   * @property gimmickSection
   * @type {JQuery}
   */
  $dom;

  /**
   * instance of registration service
   *
   * @property fileService
   * @type {FileService}
   */
  fileService;

  /**
   * formVisibility constructor
   *
   * @method initialize
   * @param element
   */
  constructor(element) {
    this.$dom = element;
    this.fileService = new FileService();

    this.fileService.initFileService(this.$dom);
  }
}

(() => {
  $("[data-file-upload]").each((idx, item) => {
    new ServiceFileManager($(item));
  });
})();
